@if (!summary) {
  <div>
    @if (meta) {
      <div class="wm-textwithtoplabel">
        <div class="toplabel">Size</div>
        <div class="text">{{meta.width}}x{{meta.height}}</div>
      </div>
    }
  </div>
  <div>@if (artifact?.data?.screenshotId) {
    <wm-image [imageId]="artifact.data.screenshotId"></wm-image>
  }</div>
}
@if (summary) {
  @if (artifact?.data?.screenshotId) {
    <div class="artifact-screenshot"><wm-image [imageId]="artifact.data.screenshotId" [small]="true" ></wm-image></div>
  }
  @if (!artifact?.data?.screenshotId) {
    <div class="noscreenshot" data-testing-id="screenshot-artifact-noscreenshot"><fa-stack size="lg"><fa-icon stackItemSize="1x" icon="camera"></fa-icon><fa-icon stackItemSize="2x" icon="ban"></fa-icon></fa-stack>
    <br>No Screenshot
    </div>
  }
}
